import { Modal, List, Tag } from "antd";
import { normalizarDiferenciaSMA } from "./detalleAuditoriaSMA.utils";

/**
 * Modal de diferencias de la auditoría SMA.
 *
 * Aparece cuando el backend rechaza el completado (codres distinto de 0) y
 * viene el campo difjsn con el detalle de qué artículos no cerraron.
 *
 * Es una lista y no una tabla a propósito: la app es mobile-first y ninguna
 * tabla con cinco columnas entra en un celular. Además el modal no lleva width
 * fijo, así que sigue el ancho por defecto de Ant Design y se acomoda solo.
 */

// Se usan los colores de tema ("error"/"success") en vez de hex, para que el
// tag se vea bien tanto en modo claro como en oscuro.
const colorDiferencia = (valor) => {
  if (valor < 0) return "error";
  if (valor > 0) return "success";
  return "default";
};

const textoDiferencia = (valor) => (valor > 0 ? `+${valor}` : `${valor}`);

const ModalDiferenciasSMA = ({ open, onClose, descri, diferencias = [] }) => {
  const filas = diferencias.map(normalizarDiferenciaSMA);

  const faltante = filas
    .filter((f) => f.diferencia !== 0)
    .reduce((sum, f) => sum + Math.abs(f.diferencia), 0);

  return (
    <Modal
      destroyOnHidden={true}
      open={open}
      onCancel={onClose}
      onOk={onClose}
      okText="Entendido"
      cancelButtonProps={{ style: { display: "none" } }}
      title="No se pudo completar la auditoría"
    >
      <div style={{ marginTop: 4 }}>
        <div style={{ marginBottom: 4 }}>
          {descri || "Se detectaron diferencias."}
        </div>

        {faltante > 0 ? (
          <div style={{ marginBottom: 8, opacity: 0.7 }}>
            {filas.length === 1 ? "1 artículo" : `${filas.length} artículos`}{" "}
            con diferencia, {faltante} unidad{faltante === 1 ? "" : "es"} sin
            justificar.
          </div>
        ) : null}

        <List
          size="small"
          dataSource={filas}
          renderItem={(fila) => (
            <List.Item style={{ padding: "10px 8px" }}>
              {/* Un solo hijo: List.Item ya es flex row, así que con dos
                  hijos quedarían uno al lado del otro en vez de apilados. */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 4,
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 8,
                  }}
                >
                  <div style={{ minWidth: 0 }}>
                    <div style={{ fontWeight: 600 }}>{fila.codigo || "-"}</div>
                    <div style={{ fontSize: 14, opacity: 0.75 }}>
                      {fila.nombre || "-"}
                    </div>
                  </div>

                  <Tag color={colorDiferencia(fila.diferencia)}>
                    {textoDiferencia(fila.diferencia)}
                  </Tag>
                </div>

                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "4px 12px",
                    fontSize: 13,
                    opacity: 0.7,
                  }}
                >
                  <span>Esperada: {fila.cantidad_esperada}</span>
                  <span>Auditada: {fila.cantidad_auditada}</span>
                  {fila.nivel ? (
                    <Tag style={{ marginInlineEnd: 0 }}>
                      Nivel {fila.nivel}
                    </Tag>
                  ) : null}
                </div>
              </div>
            </List.Item>
          )}
        />
      </div>
    </Modal>
  );
};

export default ModalDiferenciasSMA;
